import { useEffect } from 'react';

export const useOnBfCacheLoad = (callback: () => void) => {
  useEffect(() => {
    const listener = (event: PageTransitionEvent) => {
      if (event.persisted) {
        callback();
      }
    };

    window.addEventListener('pageshow', listener);

    return () => {
      window.removeEventListener('pageshow', listener);
    };
  }, [callback]);
};
